<template>
  <div class="wrap">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>员工账号</span>
        <div class="topBtn" @click="handleAdd()">新建子账号</div>
      </div>
      <!-- tableList -->
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID" width="200">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="200">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column prop="role_name" label="子账号角色" width="200">
          <template slot-scope="scope">
            {{ scope.row.role_name }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="绑定手机号" width="200">
          <template slot-scope="scope">
            {{ scope.row.phone }}
          </template>
        </el-table-column>
        <el-table-column prop="wx_num" label="微信信息" width="200">
          <template slot-scope="scope">
            {{ scope.row.wx_num }}
          </template>
        </el-table-column>
        <el-table-column prop="cretime" label="创建时间" width="200">
          <template slot-scope="scope">
            {{ scope.row.cretime }}
          </template>
        </el-table-column>
        <el-table-column prop="status_text" label="状态" width="200">
          <template slot-scope="scope">
            {{ scope.row.status_text }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="220">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              style="border: none; text-align: center"
              @click="changeStatus(scope.row)"
            >
              <div style="color: #fe2c55; font-size: 9px; font-weight: 400">
                {{ scope.row.status == 0 ? "启用" : "禁用" }}
              </div>
            </el-button>
            <el-button
              size="mini"
              type="text"
              style="border: none; text-align: center"
              @click="handleEdit(scope.row, 'edit')"
            >
              <div style="color: #fe2c55; font-size: 9px; font-weight: 400">
                修改
              </div>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination
      :total="total"
      :current_page="page"
      @sizeChange="handleSizeChange"
      @currentChange="handleCurrentChange"
    ></pagination>
    <editDialog
      :editVisible="editVisible"
      :data="eachPre"
      @close="close"
    ></editDialog>
    <addDialog
      :addVisible="addVisible"
      @close="closes"
    ></addDialog>
  </div>
</template>

<script>
// @ts-nocheck
import pagination from "@/components/Pagination";
import editDialog from "./editAccountDialog/index.vue";
import addDialog from "./addAccountDialog/index.vue";
import { manageList, changeStatus } from "@/api/manage.js";
export default {
  components: {
    pagination,
    editDialog,
    addDialog
  },
  data() {
    return {
      tableData: [],
      total: 50,
      page: 1,
      page_size: 10,
      // 编辑弹窗
      editVisible: false,
      addVisible: false,
      eachPre: {},
    };
  },
  mounted() {
    this.manageList();
  },
  methods: {
    // 修改状态
    changeStatus(info){
      this.$confirm(`确定要${info.status==0 ? '启用' : '禁用'}此账号吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          changeStatus({
            id: '1',
            status: info.status==0 ? '1' : '0'
          }).then( res => {
            if(res.code == 800){
              this.$message.success(res.msg)
              this.manageList()
            }else{
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          return
        });
    },
    // 弹窗回调
    close(info) {
      if (info === "close") {
        this.editVisible = false;
      } else {
        this.editVisible = false;
        this.manageList();
      }
    },
    // 弹窗回调
    closes(info) {
      if (info === "close") {
        this.addVisible = false;
      } else {
        this.addVisible = false;
        this.manageList();
      }
    },
    manageList() {
      manageList({
        dy_uid: "1",
        page: this.page,
        limit: this.page_size,
      }).then((res) => {
        if (res.code == 800) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        }
      });
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.manageList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.manageList();
    },
    // 编辑当前条目
    handleEdit(item) {
      this.editVisible = true;
      this.eachPre = item;
    },
    // 
    handleAdd(){
      this.addVisible = true
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-pagination {
  text-align: center;
  margin-top: 40px;
}
.wrap {
  display: flex;
  flex-direction: column;
  .box-card {
    .topBtn {
      width: 64px;
      height: 32px;
      background: #fe2c55;
      border-radius: 4px;
      float: right;
      text-align: center;
      line-height: 32px;
      color: #ffffff;
      font-size: 12px;
      padding: 0 3px;
      cursor: pointer;
    }
  }
}
</style>